import classNames from 'classnames';
import { roundedOptions } from '../editor/Toolbar/options';

export const getTabsWrapClasses = (tabsLayout) => (
	tabsLayout === 'sidebar'
		? 'flex flex-col @sm:flex-row gap-4 @sm:gap-8 items-baseline'
		: 'space-y-4 @sm:space-y-8'
);

const getTabsAlignClass = (tabsAlign) => {
	switch (tabsAlign) {
	case 'center':
		return 'justify-center';
	case 'right':
		return 'justify-end';
	case 'left':
	default:
		return 'justify-start';
	}
};

export const getTabListWrapperClasses = (tabsLayout, tabsStyle) => classNames(
	tabsLayout === 'sidebar'
		? 'shrink-0 w-full @sm:w-56'
		: classNames('relative top-0 z-5', tabsStyle !== 'background' && 'border-b'),
);

export const getTabListClasses = (tabsLayout, tabsAlign) => classNames(
	'-mb-px overflow-x-auto scrollbar-hide',
	tabsLayout === 'sidebar'
		? 'flex flex-col gap-1'
		: classNames('flex space-x-4 @sm:space-x-8', getTabsAlignClass(tabsAlign)),
);

export const getTabPanelsWrapperClasses = (tabsLayout) => classNames(
	tabsLayout === 'sidebar' && 'flex-1 min-w-0',
);

export const getTabClasses = (tabRounded) => classNames(
	'whitespace-nowrap text-base font-semibold text-left focus:outline-none px-4 py-2 transition-all duration-200',
	!!tabRounded && roundedOptions[parseInt(tabRounded, 10)],
);

export const getTabStyle = ({
	selected, tabsLayout, tabsStyle, tabColor, activeTabColor, tabBackground, activeTabBackground, tabBorderColor, tabBorderWidth,
}) => {
	const style = {
		color: selected ? activeTabColor : tabColor,
		opacity: selected || tabsStyle === 'background' ? 1 : 0.7,
		background: (selected && tabsStyle === 'background' ? (activeTabBackground || activeTabColor) : tabBackground) || undefined,
	};

	if (tabBorderWidth) {
		style.borderWidth = `${tabBorderWidth}px`;
		style.borderStyle = 'solid';
		style.borderColor = tabBorderColor || 'transparent';
	}

	if (tabsStyle === 'underline') {
		const indicatorColor = selected ? activeTabColor : 'transparent';
		if (tabsLayout === 'sidebar') {
			style.borderLeftWidth = '3px';
			style.borderLeftStyle = 'solid';
			style.borderLeftColor = indicatorColor;
		} else {
			style.borderBottomWidth = '2px';
			style.borderBottomStyle = 'solid';
			style.borderBottomColor = indicatorColor;
		}
	}

	return style;
};
